import { Component, EventEmitter, Input, OnInit, Output, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { GridOptions } from 'ag-grid-community';
import { ManualAwardsService } from '../../../services/manual-awards.service';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import { AgGridHelperService } from 'src/app/reusables/services/ag-grid-helper.service';
import { DatePipe } from '@angular/common';
import { AgGridAngular } from 'ag-grid-angular';

@Component({
    selector: 'cv-awarded-popup',
    templateUrl: './awarded-popup.component.html',
    styleUrls: ['./awarded-popup.component.scss']
})
export class AwardedPopupComponent implements OnInit, OnChanges {
    @Input() selectedAward: any;
    @Input() item: any;
    @Input() awardedIsVisible: boolean = false;
    @Output() openAwardPopup = new EventEmitter<void>();

    @ViewChild('awardedPopupGrid') agGrid: AgGridAngular;

    @Input() gridLoaded: boolean = false;
    @Output() hideAwardedPopup = new EventEmitter<void>();
    @Output() reference = new EventEmitter<void>();
    gridOptions: GridOptions = null;
    columnLocalization = new Map();
    loadingHistory: boolean = false;
    public gridReady = false;
    
    awardToolVisible = false;
    manualAward: any = {};
    loadHistory = true;
    awardAdded = false;

    constructor(
        private manualAwardsService: ManualAwardsService,
        private cvLocalizationService: CVLocalizationService,
        private agGridHelperService: AgGridHelperService,
        private datePipe: DatePipe,) {
    }

    ngOnInit(): void {
        this.loadLocalization();
        this.loadAgGridData(this.selectedAward);
    }

    async loadLocalization() {
        await this.cvLocalizationService.GetSection("Manual_Awards").then((map) => {
            this.columnLocalization = map;
            this.setupGrid();
        });
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.selectedAward && !changes.selectedAward.firstChange) {
            this.loadAgGridData(changes.selectedAward.currentValue);
        }
        if (changes.item && !changes.item.firstChange) {
            this.loadAgGridData(changes.item.currentValue);
        }
    }

    getColumnName(key: string, defaultValue: string = key): string {
        let columnNameLocalization = this.columnLocalization.get(key);

        if (columnNameLocalization && columnNameLocalization.length > 0)
            return columnNameLocalization;
        else
            return defaultValue;
    }

    setupGrid(): void {
        this.gridOptions = this.agGridHelperService.createGridOptions({
            defaultColDef: {
                sortable: true,
                filter: true,
                resizable: true,
                width: 200,
            },
            accentedSort: true,
            animateRows: true,
            suppressCellFocus: true,
            suppressDragLeaveHidesColumns: true,
            suppressScrollOnNewData: true,
            popupParent: document.querySelector('.cvGroupAssignToolPopupContainer'),
            columnDefs: [
                {
                    field: 'RecipientName',
                    headerName: this.getColumnName('Recipient_Header', 'Recipients'),
                    enableRowGroup: true,
                    lockVisible: true,
                    cellRenderer: params => {
                        return `<div class='d-flex'><div><img class='rounded-circle' src='../Admin/ImageResizer.aspx?imgid=${params.data.RecipientImageID}&w=40&h=40' /></div><div class='ml-2' style='line-height: initial;'><div class='font-size-14 mt-1'>${params.data.RecipientName}</div><div class='color-valyrianSteel'>${params.data.RecipientRole}</div></div></div>`;
                    },
                },
                {
                    field: 'DateGiven_ForView',
                    headerName: this.getColumnName('Date_Header', 'Date'),
                },
                {
                    field: 'AwarderName',
                    headerName: this.getColumnName('Awarded_Header', 'Given By'),
                    cellRenderer: params => {
                        return `<div class='d-flex'><div><img class='rounded-circle' src='../Admin/ImageResizer.aspx?imgid=${params.data.AwarderImageID}&w=40&h=40' /></div><div class='ml-2' style='line-height: initial;'><div class='font-size-14 mt-1'>${params.data.AwarderName}</div><div class='color-valyrianSteel'>${params.data.AwarderRole}</div></div></div>`;
                    },
                },
            ],
            onGridReady: (e) => {
                e.api.sizeColumnsToFit();
            },
            onGridSizeChanged: (e) => {
                e.api.sizeColumnsToFit();
            },
            localeText: { noRowsToShow: this.getColumnName('No_Rows', 'No Rows To Show') },
            rowData: [],
            // localeTextFunc: this.agGridHelperService.localeTextFunc,

        });
    }

    loadAgGridData(award) {
        this.loadingHistory = true;
        this.reference.emit(award);
        if (this.selectedAward.AwardedHistory == null || this.selectedAward.AwardedHistory.length < 1 || this.awardAdded ||
            this.selectedAward.AwardedHistory.length != this.selectedAward.AwardedCount
        ) {

            this.manualAwardsService.loadManualAwardHistory(this.selectedAward).then(
                (result: any) => {
                    if (result != null && result.length > 0) {
                        if (Array.isArray(result)) {
                            result.forEach((item, index) => {
                                (item as any)._id = index;
                            });
                        }

                        this.gridOptions.getRowId = (params) => params.data._id.toString();
                        this.item.AwardedHistory = result;
                        if (this.agGrid?.api) {

                            this.agGrid?.api.setGridOption('rowData', this.item.AwardedHistory);
                        }
                        this._setAgGridData();
                    }
                    this.awardAdded = false;
                    this.loadingHistory = false;
                },
                (error) => {
                    this.awardAdded = false;
                    this.loadingHistory = false;
                    this._setAgGridData();
                }
            );
        }
        else {
            setTimeout(() => {
                this.loadingHistory = false;
                this._setAgGridData();
            }, 0);
        }
    };

    _setAgGridData() {
        if (this.agGrid?.api) {
            this.agGrid?.api.setGridOption('rowData', this.item.AwardedHistory);
            this.agGrid?.api.sizeColumnsToFit();
            this.agGrid?.api.hideOverlay();
        }
    };
    
    onLoadHistory(){
        this.awardAdded = true;
        this.loadAgGridData(this.selectedAward); 
    }

    onOpenAwardPopup() {
        this.manualAward = this.selectedAward;
        this.awardToolVisible = true;
    }

    closeAwardPopup() {
        this.manualAward = null;        
        this.awardToolVisible = false;
    }
    
    closePopup(): void {
        this.hideAwardedPopup.emit();
    }
}
